import { Typography } from 'antd';
import type { TitleProps } from 'antd/lib/typography/Title';
import cs from 'classnames';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './title.module.css';

export type TitleProperties = {
  icon?: ReactNode;
  marginBottom?: boolean;
  marginTop?: boolean;
} & TitleProps;

const Title = ({
  children,
  className,
  ellipsis,
  icon,
  marginBottom = false,
  marginTop = false,
  ...rest
}: TitleProperties) => {
  const { t } = useTranslation();

  const tooltip = typeof ellipsis === 'object' ? ellipsis.tooltip : undefined;

  return (
    <Typography.Title
      className={cs(className, {
        [styles['margin-bottom-disabled'] ?? '']: !marginBottom,
        [styles['margin-top-disabled'] ?? '']: !marginTop,
      })}
      ellipsis={
        ellipsis
          ? {
              ...(typeof ellipsis === 'object' ? ellipsis : {}),
              tooltip: typeof tooltip === 'string' ? t(tooltip) : tooltip,
            }
          : false
      }
      {...rest}
    >
      {icon ? <span className={styles.icon}>{icon}</span> : undefined}
      {typeof children === 'string' ? t(children) : children}
    </Typography.Title>
  );
};

export default Title;
